/** Logical Storage roots for SEO OG images per entity. */
export const BRANDS_SEO_OG_STORAGE_PATH = 'brandsSeoOg'
export const PRODUCTS_SEO_OG_STORAGE_PATH = 'productsSeoOg'
export const OUTLET_PRODUCTS_SEO_OG_STORAGE_PATH = 'outletProductsSeoOg'
export const CATALOG_TAXONOMY_SEO_OG_STORAGE_PATH = 'catalogTaxonomySeoOg'

/** Regular category/node photos (not SEO OG). */
export const CATALOG_TAXONOMY_PHOTOS_STORAGE_PATH = 'catalogTaxonomy'
